var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadRecording(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.332001 42C0.332001 18.988 18.988 0.332001 42 0.332001C65.012 0.332001 83.668 18.988 83.668 42C83.668 65.012 65.012 83.668 42 83.668C18.988 83.668 0.332001 65.012 0.332001 42ZM46.168 21.168C46.168 18.8672 44.3008 17 42 17C39.6992 17 37.832 18.8672 37.832 21.168V42.547L31.8125 38.5314C29.8984 37.258 27.3086 37.7736 26.0313 39.6876C24.7579 41.6017 25.2735 44.1915 27.1875 45.4649L39.6875 53.8008C41.0898 54.7344 42.9102 54.7344 44.3125 53.8008L56.8125 45.4649C58.7266 44.1915 59.2422 41.6016 57.9687 39.6876C56.6914 37.7735 54.1015 37.2579 52.1875 38.5314L46.168 42.547V21.168ZM29.5 58.668C27.1992 58.668 25.332 60.5313 25.332 62.8321C25.332 65.1329 27.1992 67.0001 29.5 67.0001H54.5C56.8008 67.0001 58.668 65.1329 58.668 62.8321C58.668 60.5313 56.8008 58.668 54.5 58.668H29.5Z",
    fill: "#7190FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadRecording);
export default __webpack_public_path__ + "static/media/downloadRecording.5c974cbe6d3f67cce563387edd925b8c.svg";
export { ForwardRef as ReactComponent };